import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBi6BNRBguUhN4ZdMx57fcQCMzjzJnPkew",
  authDomain: "code-zephyr-de6e5.firebaseapp.com",
  projectId: "code-zephyr-de6e5",
  storageBucket: "code-zephyr-de6e5.appspot.com",
  messagingSenderId: "352630828349",
  appId: "1:352630828349:web:db8ba173c09adc3992a954",
  measurementId: "G-P99C26H19F",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
